import * as React from 'react';
import { keycloak, KeycloakContext } from './keycloak';

interface Props {
  children: React.ReactNode;
  clientId: string;
}

// ReactKeycloakProvider (@react-keycloak/web v3) is broken with keycloak-js 19+:
// it reads keycloak.token at the wrong point in the new event lifecycle, causing
// onAuthLogout to fire immediately after a successful login.
// keycloak.init() is now called in initialize() before React renders, so by the
// time this component mounts the user is always authenticated.
const KeycloakWrapper: React.FC<Props> = ({ children }) => {
  return (
    <KeycloakContext.Provider value={{ keycloak, initialized: true }}>
      {children}
    </KeycloakContext.Provider>
  );
};

export default KeycloakWrapper;